var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { apiInternalDeficiencyPath } from '@routes';
import mapper from './mapper';
export function getDeficiencyDetail(_id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(apiInternalDeficiencyPath({ id: _id }));
            return response.data.deficiency;
        }
        catch (error) {
            console.error('Error getting deficiency:', error);
            throw error;
        }
    });
}
export function updateDeficiency(_id, deficiencyUpdate) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const apiPayload = mapper(deficiencyUpdate);
        try {
            const response = yield api.patch(apiInternalDeficiencyPath({ id: _id }), {
                deficiency: apiPayload
            });
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.deficiency)) {
                throw new Error('Invalid response format from server');
            }
            return response.data.deficiency;
        }
        catch (error) {
            console.error('Error updating deficiency:', error);
            throw error;
        }
    });
}
export function deleteDeficiency(_id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.delete(apiInternalDeficiencyPath({ id: _id }));
            return response.data.deficiency;
        }
        catch (error) {
            console.error('Error deleting deficiency:', error);
            throw error;
        }
    });
}
